/**
 * SymbolType.ts
 */
export class SymbolType {
    constructor(type) {
        this.type = type;
    }
    static getType(type) {
        return SymbolType[type];
    }
    isNumber() {
        return this == SymbolType.NUMBER;
    }
    isCoin() {
        return this == SymbolType.COIN;
    }
    isFreeSpin() {
        return this == SymbolType.FREE_SPIN;
    }
    isJoker() {
        return this == SymbolType.JOKER;
    }
    isSuperJoker() {
        return this == SymbolType.SUPER_JOKER;
    }
    isDevil() {
        return this == SymbolType.DEVIL;
    }
    isBonus() {
        return this == SymbolType.BONUS;
    }
    isCollectible() {
        return this.isCollectable();
    }
    isCollectable() {
        return this === SymbolType.COLLECTABLE;
    }
    getType() {
        return this.type;
    }
    toString() {
        return this.type;
    }
}
SymbolType.NUMBER = new SymbolType("NUMBER");
SymbolType.COIN = new SymbolType("COIN");
SymbolType.FREE_SPIN = new SymbolType("FREE_SPIN");
SymbolType.JOKER = new SymbolType("JOKER");
SymbolType.SUPER_JOKER = new SymbolType("SUPER_JOKER");
SymbolType.DEVIL = new SymbolType("DEVIL");
SymbolType.BONUS = new SymbolType("BONUS");
SymbolType.COLLECTABLE = new SymbolType("COLLECTABLE");
//# sourceMappingURL=SymbolType.js.map